import { Grid, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "components/LoadingButton";
import Dialog from "components/NoScrollDialog";
import { useLanguage } from "contexts/language.context";
import * as React from "react";

export default function AreaDialog({
  isOpen,
  onSubmit,
  data,
  type,
  branchGroupId,
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [area, setArea] = React.useState({
    name: "",
  });
  const { label } = useLanguage();

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
    setArea({
      name: "",
    });
  }, [isOpen]);

  React.useEffect(() => {
    setArea({ name: data?.name });
  }, [data]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();
          event.stopPropagation();

          setLoading(true);
          const result = await onSubmit(
            type == "edit"
              ? {
                  id: data.id,
                  ...area,
                }
              : { ...area, branchGroupId },
          );
          if (result.success) {
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {type == "edit" ? label("edit-area") : label("create-area")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ pt: 1.5 }}>
          <Grid item xs={12}>
            <TextField
              autoFocus
              required
              id="name"
              name="name"
              label={label("name-singular")}
              type="text"
              value={area.name}
              onChange={(e) => {
                setArea({
                  ...area,
                  name: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {type == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
